/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable camelcase */
import { CmsLinkedBannersResponseData, CmsStaticPageResponseData } from '../../client/redux/cms/types';
import { Positions } from '../types/remoteConfig';

export interface GenericShopApiResponse<T, TError = string[]> {
    success: boolean;
    errors: TError;
    data: T;
}

export enum HeaderBarBannerVisibility {
    LOGGED_IN_USERS = 'login',
    LOGGED_OUT_USERS = 'logout',
    ALL_USERS = 'all',
}

export interface HeaderBarBannerData {
    mobileImage: {
        path: string;
        width: number;
        height: number;
    };
    desktopImage: {
        path: string;
        width: number;
        height: number;
    };
    dismissable: boolean;
    links: {
        rel: string;
        href: string;
    }[];
    visibilityOption: HeaderBarBannerVisibility;
    desktopBackgroundColor: string;
}

export enum CustomErrorTypes {
    CONNECTIVITY_ERROR = 'TypeError',
    EXTERNAL_SCRIPT_ERROR = 'Script error.',
}

export interface Configuration {
    shipping: {
        minOrderValue: number;
    };
    magalog: {
        toggle: boolean;
        url: string;
    };
    sales: {};
    shopToClub: {
        clubRegOverlayEnabled: boolean;
        clubRegOverlayMobileImage: string;
        clubRegOverlayMobileDelay: number;
        clubRegOverlayExpirationInDays: number;
        clubRegOverlayTopBorderColor: string;
        clubRegOverlayDismissable: boolean;
        clubPromoBannerImage: string;
        clubPromoBannerDesktopImage: string;
        isClubBannerDismissable: boolean;
        promoExpirationTime: number;
        isUndismissableFromOutsideClick: boolean;
        pageViewLimit: string;
    };
    clubHeaderHighlightTab: {
        toggle: boolean;
        url: string;
    };
    moodboard: {
        enableMobileEntry: boolean;
    };
    specialSales: {
        strikeThroughColor: string;
        blackFridayBadgeColor: string;
        cyberMondayBadgeColor: string;
    };
    isImageServiceProductImageEnabled: boolean;
    quantityBadgePosition: Positions;
    appboy: AppboyConfig;
    isVimeoVideoPlayerEnabled: boolean;
    isNativeVideoPlayerEnabled: boolean;
    isPdpClientSideNavigationEnabled: boolean;
    isPdpTaxDisclaimerEnabled: boolean;
}

export interface AppboyConfig {
    identifier: string;
    authentication: string;
    authentication_mobile: string;
}

export interface EmailExistsResponseData {
    exists: boolean;
    email: string;
    isNewsletterAccepted: boolean;
}

export interface IsFacebookOnlyUserData {
    isFacebookOnlyUser: boolean;
}

export type HeaderBarBannerResponse = GenericShopApiResponse<HeaderBarBannerData>;
export type ConfigurationResponse = GenericShopApiResponse<Configuration>;
export type CmsBlockStaticBlockResponse = GenericShopApiResponse<CmsLinkedBannersResponseData>;
export type CmsStaticPageResponse = GenericShopApiResponse<CmsStaticPageResponseData>;
export type ResendDoiConfirmationResponse = GenericShopApiResponse<String>;
export type EmailExistsResponse = GenericShopApiResponse<EmailExistsResponseData>;
export type IsFacebookOnlyUserResponse = GenericShopApiResponse<IsFacebookOnlyUserData>;
